import { get, put, remove } from 'communication/httpClient';
import { IGenericObject } from 'types';
import { cleanObject } from 'utils/object';
import {
  BUSINESS_DAY_DELETED,
  BUSINESS_DAY_LIST_LOADED,
  BUSINESS_DAY_LOADED,
  BUSINESS_DAY_SAVED,
  LOAD_BUSINESS_DAY,
  LOAD_BUSINESS_DAY_LIST,
  RESET_BUSINESS_DAY,
  RESET_BUSINESS_DAY_LIST,
  SAVE_BUSINESS_DAY,
  SYNC_FAILED,
} from './actionTypes';
import { IBusinessDay, IBusinessDaysActions } from './types';

export const initialActionsState = {
  loadBusinessDayList: () => {},
  loadBusinessDay: () => {},
  saveBusinessDay: () => {},
  deleteBusinessDay: () => {},
  resetBusinessDayList: () => {},
  resetBusinessDay: () => {},
};

export const getActions = (dispatch: {
  (value: { type: any; payload?: any }): void;
  (arg0: { type: string; payload?: any }): void;
}): IBusinessDaysActions => ({
  loadBusinessDayList: async (params: IGenericObject) => {
    dispatch({
      type: LOAD_BUSINESS_DAY_LIST,
    });

    const { data, error } = await get('/api/business-day', { params: cleanObject(params) });

    if (data) {
      dispatch({
        type: BUSINESS_DAY_LIST_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  loadBusinessDay: async (id: string) => {
    dispatch({
      type: LOAD_BUSINESS_DAY,
    });

    const { data, error } = await get(`/api/business-day/${id}`);

    if (data) {
      dispatch({
        type: BUSINESS_DAY_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  saveBusinessDay: async (
    businessDay: IBusinessDay,
    isNew?: boolean,
    onSuccess?: (businessDay: IBusinessDay) => void
  ) => {
    dispatch({
      type: SAVE_BUSINESS_DAY,
    });
    const { enterpriseUnitId = '' } = businessDay || {};
    const { error } = await put(`/api/business-day/${enterpriseUnitId}`, businessDay);

    if (!error) {
      dispatch({
        type: BUSINESS_DAY_SAVED,
        payload: businessDay,
      });

      if (onSuccess) onSuccess(businessDay);
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  deleteBusinessDay: async (id: string, callback?: () => void) => {
    const { data, error } = await remove(`/api/business-day/${id}`);
    if (data || data === '') {
      dispatch({
        type: BUSINESS_DAY_DELETED,
        payload: id,
      });
      if (callback) {
        callback();
      }
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  resetBusinessDayList: () =>
    dispatch({
      type: RESET_BUSINESS_DAY_LIST,
    }),
  resetBusinessDay: () =>
    dispatch({
      type: RESET_BUSINESS_DAY,
    }),
});
